// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getUsersAnalyticsApi } from "../../Service/Api/UsersAnalyticsApi"

import { getUsersAnalyticsList,getErrors } from "../Reducer/UsersAnalyticsReducer"

 

 

// Watchers
function* usersAnalyticsSaga() {
	yield takeEvery("usersAnalytics/getUsersAnalytics", getUsersAnalytics)
}

// Sagas
function* getUsersAnalytics(action) {
	// console.log(action)
	try {
		const getUsersAnalytics = yield call(getUsersAnalyticsApi, action.payload)
		// console.log(getUsersAnalytics.status);
		if (getUsersAnalytics.request.status === 200) {
			yield put( getUsersAnalyticsList(getUsersAnalytics))
			// console.log(getVendorAnalytics.status);
		} else {
			yield put(getErrors(getUsersAnalytics))
		}
	} catch (error) {

		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(usersAnalyticsSaga)])
}
